export const FreeThrowsSelect = {
  name: "free-throws-select",
  component: "MainPanel",
  layout: "main-panel full align-center",
  mode: "visible",
  text: "freethrows",
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showOn: [{ state: "secondary", value: "free-throws-select", operator: "is" }],
  children: [
    {
      name: "free-throw-select-panel",
      component: "SimpleFreeThrows",
      layout: "free-throws full",
      mode: "enable",
      text: null,
      showOn: [true],
      options: {
        allowAddingNew: true,
        currentEntity: false,
        currentEntityEvent: "foul",
        timeoutPanel: "simple-freethrow-timeout",
        timeoutPanelType: "primary",
        returnPanel: "free-throws-select",
      },
      actionGroups: [
        {
          actions: [{ action: "clearEvent", value: "freethrow", type: "main" }],
          conditions: [],
        },
        {
          // switch possession if the last free throw was successful
          actions: [
            { action: "setPossession", value: { currentEntity: false }, type: "main" },
            { action: "nextState", value: null, type: "secondary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [{ item: "success", value: true, event: "main", operator: "is" }],
        },
        {
          actions: [{ action: "startClock", value: "start", type: "main" }],
          conditions: [{ item: "success", value: false, event: "main", operator: "is" }],
        },
        {
          actions: [
            { action: "nextState", value: null, type: "secondary" },
            { action: "nextState", value: "shot-rebound", type: "primary" },
          ],
          conditions: [
            { item: "success", value: false, event: "main", operator: "is" },
            {
              item: "subType",
              value: ["technical", "categoryOneTechnical", "categoryTwoTechnical"],
              event: "foul",
              operator: "not",
            },
          ],
        },
        {
          actions: [{ action: "nextState", value: null, type: "secondary" }],
          conditions: [
            { item: "success", value: false, event: "main", operator: "is" },
            {
              item: "subType",
              value: ["technical", "categoryOneTechnical", "categoryTwoTechnical"],
              event: "foul",
              operator: "is",
            },
          ],
        },
      ],
    },
  ],
};
